import { FC, useRef } from 'react';

import { Autocomplete } from '@react-google-maps/api';

import { useGoogleMapsPlacesReady } from '@/hooks';
import { IPoint } from '@/models';

import { SearchBar } from '../SearchBar';

interface SearchAddressBarProps {
  address: string;
  onChange: (address: string, position?: IPoint) => void;
}

export const SearchAddressBar: FC<SearchAddressBarProps> = ({
  address,
  onChange,
}) => {
  const autoCompleteRef = useRef<google.maps.places.Autocomplete>();
  const isPlacesReady = useGoogleMapsPlacesReady();

  const handleLoad = (autocomplete: google.maps.places.Autocomplete) => {
    autoCompleteRef.current = autocomplete;
  };

  const handlePlaceChanged = () => {
    const selectedPlace = autoCompleteRef.current?.getPlace();
    if (selectedPlace) {
      const position = selectedPlace.geometry?.location?.toJSON();
      onChange(
        selectedPlace.formatted_address ?? '',
        position
          ? { type: 'Point', coordinates: [position.lng, position.lat] }
          : undefined,
      );
    }
  };

  const searchBar = (
    <SearchBar
      value={address}
      placeholder="Search address..."
      onChange={(str: string) => {
        onChange(str);
      }}
    />
  );

  // <Autocomplete> throws if it mounts before the Places library is loaded, and
  // that throw unmounts the whole portal through the root error boundary - which
  // is what left this page blank on a cold load. Show the plain search field
  // until Places is ready; it still filters by text and upgrades in place.
  if (!isPlacesReady) return searchBar;

  return (
    <Autocomplete
      restrictions={{ country: 'us' }}
      onLoad={handleLoad}
      onPlaceChanged={handlePlaceChanged}
      // browserAutofillEnabled
      // confirmOnBrowserAutofill
    >
      {searchBar}
    </Autocomplete>
  );
};
